import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=35534e5e&scoped=true"
import script from "./Plugins.vue?vue&type=script&lang=js"
export * from "./Plugins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35534e5e",
  null
  
)

export default component.exports